import { createApp } from 'vue';
import App from './App.vue'; // Root component


const app = createApp(App);
app.mount('#app'); // Attach to the DOM
